/**
 * @description Create shadow element
 * @param e shadow root element
 * @param containerStyle custom styles
 * @return element
 */
export function createElement(
  name: string,
  e: any,
  containerStyle?: { [key: string]: string | number },
): HTMLDivElement {
  const element = document.createElement('div');
  element.id = `${name}-container`;

  for (const key in containerStyle) {
    // @ts-expect-error wrong key type
    element.style[key] = containerStyle[key];
  }
  e.appendChild(element);

  return element;
}
